import { getInitialStateFromConfig } from "helpers/form";

const config = {
    contacts: {
        value: [],
        config: {
            name: {
                bWrapper: "row",
                inputProps: { name: "name" },
            },
            fullName: {
                bWrapper: "row",
                inputProps: { name: "fullName" },
            },
            phoneNumber: {
                bWrapper: "row",
                inputProps: { name: "phoneNumber", placeholder: "+7XXXXXXXXXX" },
            },
            isHidden: {
                bWrapper: "row",
                inputProps: { name: "isHidden" },
                checkbox: true,
            },
            id: {},
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
